export default __webpack_public_path__ + "static/image21-35605e1f7b3940e2905cc4e2f88bdad5.gif";